<br />
<div sm-center sm-restrict-width>
  <mat-card class="smc-booking-confirmation-card" *ngIf="booking.getServices().length > 0">
    <div sm-center>
      <mat-card-title>
        <mat-icon style="font-size: 48px">done</mat-icon>
        <br /><br />
        <span *ngIf="booking.getStatus() === 11">{{ 'BOOKINGS.WAITLIST_SUBMITTED' | translate }}</span>
        <span *ngIf="!requireApproval && booking.getStatus() != 11">{{ 'BOOKINGS.BOOKING_COMPLETED' | translate }}</span>
        <span *ngIf="requireApproval && booking.getStatus() != 11">{{ 'BOOKINGS.BOOKING_REQUESTED' | translate }}</span>
      </mat-card-title>
    </div>
    <span *ngIf="requireApproval || booking.getStatus() === 11">{{ 'BOOKINGS.REVIEW_CONFIRMATION' | translate }}</span>
    <h3 class="smc-booking-time" *ngIf="booking.getStatus() != 11">
      {{ confirmationTitle }}
    </h3>
    <mat-list>
      <mat-list-item *ngFor="let service of booking.getServices()">
        <h3 mat-line>
          {{ service.getName() }} with
          {{ service.getStylist().getFirstName() }}
          {{ service.getStylist().getLastName() }}
        </h3>
        <p mat-line>
          <span *ngIf="service.getStylist().getHidePrices() !== 1 && service.getServiceDefinition().getStartingAt() == 1">{{ 'BOOKINGS.STARTING_AT' | translate }}</span>
          {{ service.getStylist().getHidePrices() !== 1 ? (service.getServiceDefinition().getPrice() | salonMonsterCurrency) + ", " : "" }}
          <span *ngIf="service.getStylist().getHideDurations() !== 1">{{ 'BOOKINGS.ABOUT' | translate }} {{ service.getDurations().startDuration + service.getDurations().processDuration + service.getDurations().finishDuration | SalonMonsterFormatDurationPipe }}</span>
        </p>
      </mat-list-item>
    </mat-list>
  </mat-card>
  <br />

  <!--   <div>
    Notes for your service provider
  </div>
 -->
  <br />
  <!--   <button
    mat-raised-button secondaryButton
    >
    Add it to your calendar
  </button> -->
  <br />
  <button
    mat-raised-button
    (click)="newBookings()"
    class="smc-button-secondary"
  >
    {{ 'BOOKINGS.BOOK_ANOTHER' | translate }}
  </button>
  <br /><br />
</div>
